import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ColorPickerComponent } from './components/color-picker/color-picker.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ErrorNotificationDialogComponent } from './dialogs/error-notification-dialog/error-notification-dialog.component';
import { ReactiveFormsModule } from "@angular/forms";
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfirmationDialogComponent } from './dialogs/confirmation-dialog/confirmation-dialog.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AppSelectorComponent } from './components/app-selector/app-selector.component';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ServiceSelectorComponent } from './components/service-selector/service-selector.component';
import { CategoriesSelectorComponent } from './components/categories-selector/categories-selector.component';
import { AppListSelectorComponent } from './components/app-list-selector/app-list-selector.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AppSelectorControlComponent } from './components/app-selector-control/app-selector-control.component';
import { CountrySelectorComponent } from './components/country-selector/country-selector.component';
import { CopyToClipboardDirective } from './directives/copy-to-clipboard.directive';

@NgModule({
    declarations: [
        ColorPickerComponent,
        FileUploadComponent,
        ErrorNotificationDialogComponent,
        ConfirmationDialogComponent,
        AppSelectorComponent,
        ServiceSelectorComponent,
        CategoriesSelectorComponent,
        AppListSelectorComponent,
        AppSelectorControlComponent,
        CountrySelectorComponent,
        CopyToClipboardDirective
    ],
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        TranslateModule,
        MatInputModule,
        FormsModule,
        MatCheckboxModule,
        MatButtonModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatSelectModule,
        DragDropModule,
        NgxMatSelectSearchModule
    ],
    exports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        TranslateModule,
        MatInputModule,
        FormsModule,
        MatCheckboxModule,
        MatButtonModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatSelectModule,
        DragDropModule,
        NgxMatSelectSearchModule,

        ColorPickerComponent,
        FileUploadComponent,
        ErrorNotificationDialogComponent,
        ConfirmationDialogComponent,
        AppSelectorComponent,
        ServiceSelectorComponent,
        CategoriesSelectorComponent,
        AppListSelectorComponent,
        AppSelectorControlComponent,
        CountrySelectorComponent,
        CopyToClipboardDirective
    ]
})
export class SharedModule { }
